<template>
  <div class="cooperation-add-wrapper global-card">
    <bread-crumb />
    <div class="org-mseeage-wrapper">
      <a-card
        :bordered="false"
        style="width: 100%; border-radius: 10px; position: relative"
      >
        <div class="title">服务计划</div>
        <a-spin
          v-if="detailsLoading"
          style="margin: auto; position: absolute; left: 50%; top: 50%"
        />
        <div class="orginfo-wrapper">
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">计划名称</p>
              <p class="flex-item-right" style="text-align: right">
                {{ orgInfo.title }}
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">任务名称</p>
              <p class="flex-item-right" style="text-align: right">
                {{ orgInfo.title1 }}
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">服务商</p>
              <p class="flex-item-right" style="text-align: right">
                {{ orgInfo.qichacha_name }}
              </p>
            </div>
          </div>
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">物料费</p>
              <p class="flex-item-right" style="text-align: right">
                {{ orgInfo.materials_cost }}元
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">发票金额</p>
              <p class="flex-item-right" style="text-align: right">
                {{ orgInfo.invoice_money }}元
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">服务城市</p>
              <p class="flex-item-right" style="text-align: right">
                {{ orgInfo.provinceCity }}
              </p>
            </div>
          </div>
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">开始时间</p>
              <p class="flex-item-right" style="text-align: right">
                {{ orgInfo.plan_start_time }}
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">结束时间</p>
              <p class="flex-item-right" style="text-align: right">
                {{ orgInfo.plan_end_time }}
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">目标产品</p>
              <div class="flex-item-right" style="text-align: left">
                <span
                  v-for="(item, index) in orgInfo.link_products"
                  :key="index"
                  >（{{ index + 1 }}）、{{ item.title }}；</span
                >
              </div>
            </div>
            <div class="flex-item-content" style="margin-top: 14px">
              <p class="flex-item-left" style="text-align: left">关联资料</p>
              <div class="flex-item-right" style="text-align: left">
                <span v-for="(item, index) in orgInfo.datas" :key="index"
                  >（{{ index + 1 }}）、【{{
                    item.link_datas.obj_type_text
                  }}】{{ item.link_datas.name }}；</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="title">分配详情</div>
        <div style="padding: 20px">
          <a-table
            :pagination="false"
            :columns="columns1"
            :data-source="tableData"
            :row-key="(record) => record.id"
          >
            <template slot="amount" slot-scope="amount, record">
              {{
                record.per_cost && record.plan_num
                  ? `${record.per_cost * record.plan_num}元`
                  : ""
              }}
            </template>

            <!-- 关联产品 -->
            <template
              slot="related_product"
              slot-scope="related_product, record"
            >
              {{ record.relation_for_product.title }}
            </template>

            <!-- 关联资料 -->
            <template
              slot="related_informations"
              slot-scope="related_informations, record"
            >
              <p
                v-for="(item, index) in record.relation_for_datas"
                :key="index"
              >
                {{ index + 1 }}).【{{ item.link_datas.obj_type_text }}】{{
                  item.title
                }}
              </p>
            </template>

            <template slot="operation" slot-scope="operation, record">
              <!-- 线上调研 -->
              <div style="display: flex" v-if="record.id == 19">
                <div>
                  <el-checkbox v-model="record.offline_share.offline" disabled
                    >线下</el-checkbox
                  >
                </div>
                <div style="margin-left: 20px">
                  <el-checkbox v-model="record.offline_share.share" disabled
                    >分享</el-checkbox
                  >
                </div>
              </div>

              <div
                style="display: flex"
                v-if="record.id == 16 || record.id == 20 || record.id == 21"
              >
                {{ record.relation_product_name_specs.join("；") }}
              </div>
            </template>

            <template slot="footer">
              <div style="overflow: hidden">
                <span style="float: left">计划总额</span>
                <span style="float: right; padding-right: 131px"
                  >{{ `${getTotal(tableData)}元` }}
                </span>
              </div>
            </template>
          </a-table>
        </div>
        <div
          v-if="DetailsUtils.getBtnText($role, Status).isShowRadio"
          style="margin-top: 30px"
        >
          <div class="title">是否同意</div>
          <a-form :form="form" style="padding: 20px 20px 0 30px">
            <a-form-item>
              <a-radio-group
                v-decorator="['verify_result', { initialValue: 1 }]"
                name="verify_result"
              >
                <a-radio :value="1"> 同意 </a-radio>
                <a-radio :value="0"> 不同意 </a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item>
              <a-textarea
                v-decorator="['verify_desc']"
                placeholder="无异议"
                :autosize="{ minRows: 2 }"
              />
            </a-form-item>
          </a-form>
        </div>
        <details-button
          class="form-card-button"
          :submit-is-show="DetailsUtils.getBtnText($role, Status).submitIsShow"
          @onCancel="onCancel"
          @onSubmit="onSubmit"
        />
      </a-card>
    </div>
  </div>
</template>
<script>
import DetailsUtils from "../utils/getDetailsStatus.js";
import DetailsButton from "../components/DetailsButton.vue";
import { columns1 } from "./../data";
export default {
  components: { DetailsButton },
  data() {
    return {
      agreement_service: [],
      detailsLoading: false,
      orgInfo: {},
      data2: [],
      DetailsUtils,
      Status: undefined,
      form: this.$form.createForm(this),
      cityData: [],
      columns1,
      tableData: [],
    };
  },
  created() {
    this.$role = this.$store.state.user.role;
    // 获取status
    this.Status = parseInt(this.$route.query.status);
    // 数据回显
    this.getAgreemntInfo({ id: this.$route.query.id });
  },
  methods: {
    // 数据回显
    async getAgreemntInfo(id) {
      let result = await this.$http.post("/WorkPlan/show", id);
      if (result.data.status === 1) {
        let res = result.data.data;
        this.orgInfo = {
          title: res.agreement_info.title,
          title1: res.title,
          qichacha_name:
            res.agreement_info.service_provider_info.companyInfo.qichacha_name,
          materials_cost: res.materials_cost,
          invoice_money: res.invoice_money,
          provinceCity: res.agreement_info.path_txt,
          plan_start_time: this.$Format(res.plan_start_time),
          plan_end_time: this.$Format(res.plan_end_time),
          link_products: res.agreement_info.agreement_product_current,
          datas: res.datas,
        };
        // 回显
        this.tableData = res.service_detail.map((item) => {
          return {
            money: item.budget,
            id: item.id,
            name: item.name,
            budget: item.budget,
            per_cost: item.per_cost,
            plan_num: item.plan_num,
            offline_share: item.configs,
            relation_product_name_specs: item.relation_product_name_specs,
            relation_for_product: item.relation_for_product || {},
            relation_for_datas: item.relation_for_datas,
          };
        });
      }
    },

    // 获取计划总金额
    getTotal(data) {
      let count = 0;
      data.forEach((item) => {
        if (item.per_cost && item.plan_num) {
          count += item.per_cost * item.plan_num;
        }
      });
      return count;
    },
    // 提交
    async onSubmit() {
      let result;
      // 企业
      if (this.$role === 0) {
        let values = this.form.getFieldsValue();
        values.desc = values.desc || "";
        // 审核
        result = await this.$http.post("/WorkPlan/verify", {
          id: this.$route.query.id,
          ...values,
        });
      } else {
        // 服务商
        if (this.Status === 1) {
          let values = this.form.getFieldsValue();
          values.desc = values.desc || "";
          result = await this.$http.post("/agreement/submit", {
            ...values,
            id: this.$route.query.id,
          });
        }
        if (this.Status === 4) {
          result = await this.$http.post("/WorkPlan/verify", {
            id: this.$route.query.id,
          });
        }
      }
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.$router.back();
      }
    },
    // 取消
    onCancel() {
      this.$router.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.cooperation-add-wrapper {
  margin-bottom: 40px;
  .business-scope-wrapper {
    .business-scope-head {
      margin-top: -35px;
      font-size: 16px;
    }
    .business-scope-content {
      background: rgba(249, 249, 252, 1);
      border-radius: 10px;
      padding: 20px;
      margin: 20px 10px;
      min-height: 100px;
    }
  }
  .form-card-wrapper {
    margin-top: 20px;
    .ant-card-body {
      display: block;
      padding-bottom: 0;
    }
  }
  .form-card-upload {
    .upload-title {
      position: relative;
      top: -9px;
      right: -191px;
      color: #c3c7d5;
      font-size: 12px;
    }
    .ant-upload-text {
      color: #d6daea;
      margin-top: 50px;
    }
  }
  .form-card-button {
    background: #f9f9fc;
    margin: 50px -32px -24px -32px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    transform: translateY(10px);
  }
  .table-input {
    padding-top: 28px;
    .error-note {
      margin-top: 6px;
      color: #f5222d;
      height: 20px;
    }
  }
  .form-card-title {
    border-left: 1px solid #46d3dd;
    margin-left: -32px;
    padding-left: 20px;
    font-size: 16px;
    color: #565c66;
    .error-note-title {
      color: #f5222d;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .input-number {
    width: 200px;
  }
}
</style>
